/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
// Register before authClient starts its dynamic MSAL import.
import './chunkRecovery';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

// Opt in to the dev render profiler with localStorage.setItem('pa:react-scan', '1') and reload.
// Walking every React fiber/context during heavy window layouts can itself stall the UI.
// Keep profiling out of normal localhost use, automation and production builds.
if (import.meta.env.DEV && !navigator.webdriver && localStorage.getItem('pa:react-scan') === '1') {
  void import('react-scan').then(({ scan }) => scan({ enabled: true }));
}
import './index.css';
import '@fontsource-variable/inter';
import { MsalProvider } from '@azure/msal-react';
import { Await } from 'react-router-dom';
import App from './App';
import { pca } from './authClient';
import LoadingScreen from './LoadingScreen';

const container = document.getElementById('root');
const root = createRoot(container as Element);

root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingScreen />}>
      <Await resolve={pca}>
        {(resolvedInstance) => (
          <MsalProvider instance={resolvedInstance}>
            <App />
          </MsalProvider>
        )}
      </Await>
    </Suspense>
  </React.StrictMode>,
);
